import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HelperService} from './helpers';
import {Observable, of, ReplaySubject} from 'rxjs';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  private contractors = [];
  private contractors$: ReplaySubject<any> = new ReplaySubject(1);

  private contractor$: any = {};

  constructor(
    private http: HttpClient,
    private helper: HelperService,
  ) {
  }

  getContractors(force: boolean = false): Observable<any> {
    this.loadContractors(force);
    if (force) {
      this.contractors$ = new ReplaySubject(1);
    }
    return this.contractors$;
  }

  getContractor(id): Observable<any> {
    if (!this.contractor$[id]) {
      this.contractor$[id] = new ReplaySubject(1);
    }
    this.loadContractor(id);
    return this.contractor$[id];
  }

  reloadContractor(id) {
    this.loadContractor(id, true);
    //this.loadContractors(true);
  }

  loadContractors(force: boolean = false) {
    if (this.contractors.length === 0 || force) {
      this.http.get(this.helper.getApiUrl('/zdravstvene-ustanove')).subscribe((contractors: any[]) => {
        this.contractors$.next(contractors);
        this.contractors = contractors;
      });
    }
  }

  loadContractor(id, force: boolean = false) {
    let contractor = null;
    if (this.contractors.length > 0) {
      contractor = this.contractors.findIndex((con) => {
        return con.id === id;
      });
    }

    if (contractor === null || contractor === -1 || force) {
      this.http.get(this.helper.getApiUrl('/zdravstvene-ustanove/' + id)).subscribe((newContractor) => {
        if (contractor === null || contractor === -1) {
          this.contractors.push(newContractor);
        } else {
          this.contractors[contractor] = newContractor;
        }
        this.contractor$[id].next(newContractor);
        this.contractors$.next(this.contractors);
      });
    }
  }
}
